module.exports = __webpack_public_path__ + "static/tab_fct3-3b7634812a5c4475cb721c9b94dd8843.jpg";